import { Box } from '@deity/falcon-ui';
import { mapRecord } from '@deity-io/di-data-basics';
import type { DictDefinition, ListDefinition } from '@deity-io/di-data-structure-editor';
import { FieldDefinition } from '@deity-io/di-data-structure-editor';
import { Collapsible } from 'components/PropertyListEditor/Collapsible';
import PropertyListEditor from 'components/PropertyListEditor/PropertyListEditor';
import { SchemaActionTypes, SchemaContext } from 'contexts/SchemaContext';
import _ from 'lodash';
import type { FC } from 'react';
import { useContext } from 'react';

interface EditFieldDefaultProps {
  locked: boolean;
  path: Array<string>;
  schema: DictDefinition | ListDefinition | FieldDefinition;
}
const EditFieldDefaults: FC<EditFieldDefaultProps> = ({ locked, path, schema }) => {
  const ctx = useContext(SchemaContext);

  const fieldProperties = schema.getProperties();
  const typeProperties = FieldDefinition.isItMe(schema) ? schema.getTypeProperties() : {};

  const overriddenTypeProperties = mapRecord(typeProperties, (property, key) => {
    if (typeof schema.config.type === 'object' && key in schema.config.type[Object.keys(schema.config.type)[0]]) {
      return property;
    }

    return undefined;
  });

  return (
    <Box>
      <Collapsible
        title="Field Settings"
        propertyBag={schema.config}
        propertyList={fieldProperties}
        itemTitle="PROPERTIES"
      >
        <PropertyListEditor
          propertyList={fieldProperties}
          data={schema.config}
          owner={schema}
          locked={ctx?.state.locked}
          onChange={(key, value) => {
            ctx?.dispatch({
              type: SchemaActionTypes.UPDATE_SETTING,
              payload: { path, property: key, value }
            });
          }}
          onDelete={key => {
            ctx?.dispatch({
              type: SchemaActionTypes.UPDATE_SETTING,
              payload: { path, property: key, value: undefined }
            });
          }}
        />
      </Collapsible>
      {!_.isEmpty(typeProperties) && (
        <Collapsible
          title="Type Settings"
          propertyBag={overriddenTypeProperties}
          propertyList={typeProperties}
          itemTitle="PROPERTIES"
        >
          <PropertyListEditor
            propertyList={typeProperties}
            data={typeof schema.config.type === 'string' ? {} : schema.config.type[Object.keys(schema.config.type)[0]]}
            owner={schema}
            locked={ctx?.state.locked || locked}
            onChange={(key, value) => {
              ctx?.dispatch({
                type: SchemaActionTypes.UPDATE_SETTING,
                /**
                 * @todo Object.keys(schema.config.type)[0] is type is string
                 */
                payload: { path, property: ['type', Object.keys(schema.config.type)[0], ...key], value }
              });
            }}
            onDelete={key => {
              ctx?.dispatch({
                type: SchemaActionTypes.UPDATE_SETTING,
                /**
                 * @todo Object.keys(schema.config.type)[0] is type is string
                 */
                payload: { path, property: ['type', Object.keys(schema.config.type)[0], ...key], value: undefined }
              });
            }}
          />
        </Collapsible>
      )}
    </Box>
  );
};

export default EditFieldDefaults;
